module.exports = __webpack_public_path__ + "static/media/leadership.7572c37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/leadership.png
// module id = 272
// module chunks = 0